import { ComponentType, Suspense } from 'react';
import ErrorBoundary from './components/Error/Boundary';
import Fallback from './components/Fallback';
import { LoginWrapper } from './login';
import { ToastProvider } from './contexts/ToastContext';
import { getOrganisation } from './utils/common';
import { Organisation } from './enums/common';

const layout = (Component: ComponentType) =>
    function LayoutComponent(props: any) {
        const renderComponent = () => {
            const isPublicNpsRoute = window.location.pathname.includes('/nps/');

            if (!isPublicNpsRoute && getOrganisation() === Organisation.IXIGO)
                return (
                    <LoginWrapper>
                        <Component {...props} />
                    </LoginWrapper>
                );

            return <Component {...props} />;
        };

        return (
            <Suspense fallback={<Fallback />}>
                <ErrorBoundary>
                    <ToastProvider>{renderComponent()}</ToastProvider>
                </ErrorBoundary>
            </Suspense>
        );
    };

export default layout;
